import { Component, OnInit } from '@angular/core';

import { AdminService } from '@services/admin.service';

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss'],
  standalone: false
})
export class JobsComponent implements OnInit {

  public functions: string[] = [];
  public functionsInfo: any[] = [];
  public warnDateLongRunning: Date = new Date();
  public warnDateNotRunning: Date = new Date();

  constructor(
    private adminService: AdminService,
  ) {
    // Minus 2 days
    this.warnDateNotRunning.setDate(this.warnDateNotRunning.getDate() - 2);

    // Minus 90 min
    this.warnDateLongRunning.setMinutes(this.warnDateLongRunning.getMinutes() - 90);
  }

  ngOnInit(): void {
    this.adminService.fetchFunctionsInfo().then((result: any) => {
      result = (result || []).map((item: any) => {
        if (item.lastStart && item.lastStop && item.lastStart < item.lastStop) {
          item.duration = new Date((item.lastStop - item.lastStart));
        }
        return item;
      });
      this.functionsInfo = result.sort((a: any, b: any) => {
        return a.id.localeCompare(b.id);
      });
    });
  }

}